<template>
  <v-text-field
    ref="inputRef"
    :value="formattedValue"
    v-bind="$attrs"
    :data-test="dataTest"
    clearable
    class="entsys--white-background-input"
    outlined
    @change="v => $emit('change', v)"
    @click:clear="() => $emit('input', null)"
    @blur="
      $event => {
        $emit('blur', $event);
      }
    "
  >
    <template #append-outer><slot name="append-outer"/></template>
  </v-text-field>
</template>

<script>
import { onUnmounted, watch } from "vue";
import i18next from "i18next";
import { getFederationConfiguration } from "@composables/masterdata/config";
import { useCurrencyInput } from "vue-currency-input";

export default {
  name: "AppInputCurrency",
  props: {
    value: {
      type: Number,
      default: 0
    },
    dataTest: {
      type: String,
      default: null
    }
  },
  setup(props) {
    const { masterConfiguration } = getFederationConfiguration();
    const { inputRef, formattedValue, setOptions, setValue } = useCurrencyInput(
      {
        currency: masterConfiguration.value.currency,
        locale: i18next.language,
        currencyDisplay: "symbol"
      },
      false
    );

    watch(
      () => props.value,
      value => {
        setValue(value);
      }
    );

    function changeLocale(newLng) {
      setOptions({
        currency: masterConfiguration.value.currency,
        locale: newLng,
        currencyDisplay: "symbol"
      });
    }
    i18next.on("languageChanged", changeLocale);
    onUnmounted(() => {
      i18next.off("languageChanged", changeLocale);
    });

    return {
      inputRef,
      formattedValue
    };
  }
};
</script>
<style>
.entsys--white-background-input .v-input__icon--append {
  margin: 0 6px;
}
</style>
